export default __webpack_public_path__ + "static/media/logo.aca9f4a0.png";